/** API route map: URLS.Controller.Payroll */
export const Payroll = {
      Name: 'Payroll/',
      GetMainGridTiles: 'tiles',
      GetMainGridData: 'get-all',
      GetClientPayGroups: 'client-pay-groups',
      GetGroupEmployees: 'pay-group-employees',
      GetDrafts: 'client-draft-pay-groups',
};
